module.exports =
  '_GROUP':
    'TITLE': "グループ"
    'PAGE_TITLE': "Group Registration"
    'CREATE_GROUP': '新規グループ作成'
    'CUSTOMIZE_GROUP': 'グループのカスタマイズ'
    'ADD_IMAGE': 'ここのカバー写真を追加できます'
    'UPLOAD_PHOTO': '写真をアップロード'
    'SELECT_PHOTO': '写真を選択'
    'GROUP_ICON_TITLE': 'グループ画像'
    'GROUP_ICON': 'グループ画像を設定'
    'GROUP_NAME': 'グループ名'
    'ABOUT_GROUP': '説明'
    'ABOUT_GROUP_DETAIL': 'グループの説明です'
    'PRIVACY_SETTINGS': 'プライバシー設定を選択'
    'PRIVATE_GROUP': '非公開グループ'
    'PRIVATE_GROUP_DES': 'メンバーのみが閲覧できます。'
    'PUBLIC_GROUP': '公開グループ'
    'PUBLIC_GROUP_DES': '誰でもグループとそのメンバーを閲覧できます。'
    'TITLE_CANCEL': 'キャンセル'
    'TITLE_CREATE': '作成'
    'NO_DATA': 'データがありません。'
    'IN_PREPARE': '現在、準備中です。'
    'EDIT':
      'PAGE_TITLE': "Group Edit"
      'CHANGE_COVER': 'カバー写真を変更'
      'CHANGE_ICON': 'グループ画像を変更'
      'TITLE_SAVE': '保存'
    'LIST':
      'PAGE_TITLE': "Group List"
      'CREATE_GROUP': '新規グループ作成'
      'SEARCH_GROUP': 'グループを検索'
      'LIST_GROUP': '参加グループ'
      'PUBLIC_GROUP': '公開'
      'PRIVATE_GROUP': '非公開'
      'MEMBERS': '参加人数'
      'MEMBERS_EXT': '名'
      'EDIT_GROUP': '編集・管理'
      'COPY_GROUP': '招待URLをコピー'
    'TOOLBAR':
      'JOINED': '参加済み'
      'LEAVE_GROUP': 'このグループを退出する'
      'INFORMATION': '情報'
      'REQUEST': 'リクエスト'
      'IN_REQUEST': 'リクエスト中'
      'INVITATION': '招待'
      'EDIT_MEMBER': 'メンバー編集'
      'NOT_ALLOWED_LEAVE_GROUP': '管理者不在になるため、変更できません'
      'CONFIRM_MESS_LEAVE_GROUP': 'グループを退出してよろしいですか？'
      'REQUEST_MESS_JOIN_GROUP': 'リクエストがグループ管理者に送信されました。'
      'COPY_MESS_URL': 'URLをコピーしました。'
    'DETAIL_TABS':
      'TIMELINE': 'タイムライン'
      'EVENT': 'イベント'
      'RANKING':'ランキング'
    'SEARCH':
      'JOINED_GROUP_LIST' : '参加グループ一覧'
      'SEARCH_RESULTS': '検索結果'
      'JOINED': '参加中'
    'CROP':
      'TITLE': 'トリミング'
      'CANCEL': 'キャンセル'
      'DONE': '完了'



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/groups/i18n/ja.coffee